import { get } from "@/services/axiosUitils";

const base = "/menu/menus/";

class MenuService {
  listMenus = async (): Promise<any> => {
    return await get(base);
  };
}

export default new MenuService();
